export default __webpack_public_path__ + "static/media/linkedin.24bbb152.png";